import { useState } from "react";

import { Column, DialogWrapper, Text } from "@bridgesplit/ui";
import { SelectStrategyDuration, AppButton } from "app/components/common";
import { StrategyDuration } from "@bridgesplit/abf-react";
import { AppDialog, useAppDialog } from "app/utils";

import { HeaderWithClose } from "../../common";

export function WindSetTermDialog() {
    const { getData, close } = useAppDialog();
    const data = getData(AppDialog.WindSetTerm);

    const [selectedDuration, setSelectedDuration] = useState<StrategyDuration | undefined>(data?.strategyDuration);

    return (
        <DialogWrapper onClose={close}>
            <Column spacing={2}>
                <HeaderWithClose close={close} header="Select duration" />
                <Text variant="body2" color="caption">
                    Select a duration to fix the borrow rate (defaults to 1D)
                </Text>

                <SelectStrategyDuration
                    strategyDurations={data?.strategyDurations}
                    strategyDuration={selectedDuration}
                    setStrategyDuration={setSelectedDuration}
                />

                <AppButton
                    isTransaction={false}
                    disabled={!selectedDuration}
                    onClick={() => {
                        if (!selectedDuration) return;
                        data?.setStrategyDuration(selectedDuration);
                        close();
                    }}
                >
                    Confirm
                </AppButton>
            </Column>
        </DialogWrapper>
    );
}
